import * as t from "react";
import { forwardRef as o } from "react";
const s = o(function(e, r) {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M4 4L4 20",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M20 20L4 20",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M19.78 7.28577L12.61 14.4633L9.7375 11.5908L4 17.3283",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.125
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M15.7943 6.88855H19.8915V10.9857",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.28571
      }
    )
  );
});
export {
  s as Stats
};
